import React, { useMemo } from 'react';
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import styled from 'styled-components';
import { Card, CardBody, CardSubhead, CardTitle } from '@spark/ui-components/components/Card';

const TotalCargasUltimosDiasCard = ({
  data,
  loading,
  blockedMessage
}) => {
  const totalCargas = useMemo(
    () => data.reduce((total, item) => total + (Number(item.totalCargas) || 0), 0),
    [data]
  );

  return (
    <Card>
      <CardBody>
        <CardTitle>Total de cargas</CardTitle>
        <CardSubhead>Volume agendado nos ultimos dias</CardSubhead>

        <ChartArea>
          {blockedMessage ? (
            <BlockedState>
              <strong>Periodo muito amplo para este grafico.</strong>
              <span>{blockedMessage}</span>
            </BlockedState>
          ) : loading ? (
            <EmptyState>Carregando metricas...</EmptyState>
          ) : data.length === 0 ? (
            <EmptyState>Nenhum registro encontrado.</EmptyState>
          ) : (
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={data} margin={{ top: 12, right: 28, left: 0, bottom: 0 }}>
                <defs>
                  <linearGradient id="totalCargasGradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#19bce5" stopOpacity={0.85} />
                    <stop offset="95%" stopColor="#19bce5" stopOpacity={0.04} />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="data" tickLine={false} axisLine={false} />
                <YAxis allowDecimals={false} tickLine={false} axisLine={false} />
                <Tooltip />
                <Area
                  type="monotone"
                  dataKey="totalCargas"
                  name="Total de Cargas"
                  stroke="#19bce5"
                  strokeWidth={3}
                  fill="url(#totalCargasGradient)"
                  dot={{ r: 4, strokeWidth: 0, fill: '#19bce5' }}
                  activeDot={{ r: 5 }}
                />
              </AreaChart>
            </ResponsiveContainer>
          )}
        </ChartArea>

        <LegendFooter>
          <LegendItem>
            <LegendDot />
            <span>Total de Cargas: {totalCargas}</span>
          </LegendItem>
        </LegendFooter>
      </CardBody>
    </Card>
  );
};

const ChartArea = styled.div`
  height: 290px;
  margin-top: 18px;
`;

const EmptyState = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  background: #f8f9fa;
  border: 1px dashed #d8dde3;
`;

const BlockedState = styled(EmptyState)`
  flex-direction: column;
  gap: 8px;
  padding: 24px;
  text-align: center;

  strong {
    color: #4b5563;
  }

  span {
    max-width: 560px;
    line-height: 1.5;
  }
`;

const LegendFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 18px -20px -20px;
  padding: 12px 20px 18px;
  border-top: 1px solid #d8dde3;
`;

const LegendItem = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #4b5563;
  font-size: 13px;
  font-weight: 600;
`;

const LegendDot = styled.span`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #19bce5;
  display: inline-block;
  flex: 0 0 14px;
`;

export default TotalCargasUltimosDiasCard;
